<template>
    <div
        id="app"
        :class="theme"
    >
        <router-view></router-view>
    </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import HeartBeatsMixin from "@/mixins/HeartBeatsMixin";
import { useAppStore } from "@/stores/app";
import { useAuthStore } from "@/stores/auth";
import { useChoicesStore } from "@/stores/choices";
import { useCompanyStore } from "@/stores/company";
import { usePaymentsStore } from "@/stores/payments";
import { useThemeStore } from "@/stores/theme";

export default {
    name: "App",
    mixins: [HeartBeatsMixin],
    computed: {
        ...mapState(useThemeStore, ["theme"]),
        ...mapState(useAppStore, ["initialized"]),
    },
    async mounted() {
        await this.fetchChoices();

        this.initApp();
        this.initPayments();

        const companyData = await this.$request("/company");
        this.initCompany(companyData);

        if (import.meta.env.VITE_APP_PING !== "false") {
            setInterval(async () => {
                await this.ping();
            }, 30000);
        }
    },
    methods: {
        ...mapActions(useAppStore, ["initApp", "setBuild"]),
        ...mapActions(useCompanyStore, ["initCompany"]),
        ...mapActions(useChoicesStore, ["fetchChoices"]),
        ...mapActions(useAuthStore, ["initAuth", "clearAuth", "ping"]),
        ...mapActions(usePaymentsStore, ["initPayments"]),
    },
};
</script>

<style lang="scss">
@use './assets/broly.css';
@use './assets/broly-file.css';
@use './assets/broly-timeline.css';
@use './assets/broly-badge.css';
@use './assets/t3admin';
</style>
